import { useEffect, useMemo, useState } from 'react';
import { listPlayers } from '../../api/americanas';
import { buildPlayersById, createPlayerNameFormatter, formatWithLastInitial } from './playerUtils';

export default function usePlayersDirectory() {
    const [players, setPlayers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let isMounted = true;
        (async () => {
            try {
                const loadedPlayers = await listPlayers();
                if (isMounted) {
                    setPlayers(loadedPlayers);
                    setError(null);
                }
            } catch (e) {
                if (isMounted) {
                    setError(e);
                    console.error('Error cargando jugadoras para la americana', e);
                }
            } finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        })();

        return () => {
            isMounted = false;
        };
    }, []);

    const playersById = useMemo(() => buildPlayersById(players), [players]);
    const formatPlayerName = useMemo(() => createPlayerNameFormatter(playersById), [playersById]);

    return {
        players,
        playersById,
        formatPlayerName,
        formatWithLastInitial,
        loading,
        error,
    };
}
